import { ChangeEvent, Dispatch, SetStateAction } from 'react';
import { Typography } from '@mui/joy';
import UploadFile from '../../UploadFile/UploadFile';
import { RunTestBulkInitialValues } from '../RunTestBulk';
import './ExcelBulkImport.css';

interface ExcelBulkImport {
  handleUpload: (
    e: ChangeEvent<HTMLInputElement>,
    values: RunTestBulkInitialValues,
    setValues: Dispatch<SetStateAction<RunTestBulkInitialValues>>
  ) => void;
  values: RunTestBulkInitialValues;
  setValues: Dispatch<SetStateAction<RunTestBulkInitialValues>>;
  importError?: string;
}

const ExcelBulkImport = ({ handleUpload, values, setValues, importError }: ExcelBulkImport) => {
  return (
    <div style={{ marginBottom: 20 }}>
      <div className={'run-test-download-template'}>
        <a
          href="/templates/Athena_Bulk-template_Broken-Link_v.1.0.xlsx"
          className={'run-test-download-template-link'}
          download
        >
          Download template
        </a>
      </div>
      <div className={`form-control form-control--no-margin`}>
        <UploadFile
          label="Upload Excel"
          onChange={(e: ChangeEvent<HTMLInputElement>) => handleUpload(e, values, setValues)}
          hasError={!!importError}
        />
        {importError && (
          <Typography textAlign="center" level="body-md" color="danger" sx={{ mt: 1 }}>
            {importError}
          </Typography>
        )}
      </div>
    </div>
  );
};

export default ExcelBulkImport;
